import { Component, OnInit } from '@angular/core';
import {
  getFirstJointOffer,
  isPayer,
  MobileProduct,
  Option,
  PlcCodes,
} from '@dch/products-business-logic';
import { CustomerAccount } from '@proximus/common-business-logic';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import {
  ApplicationState,
  getSelectedProductDetails,
  getUserProduct,
} from '../../../../store/reducers';
import { Store } from '@ngrx/store';
import { CustomerService, TranslationService } from '@proximus/ng-common';
import { GetProductDetails } from '../../../../store/actions/product-details.actions';
import { getPiiServiceId, savePii } from '../../../../shared/pii/pii.utils';
import { ActivatedRoute, Router } from '@angular/router';
import * as ProductsActions from '../../../../store/actions/products.actions';

@Component({
  selector: 'mprd-joint-offer',
  templateUrl: './joint-offer.component.html',
})
export class JointOfferComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  mobileProductDetails: MobileProduct;
  customerAccount: CustomerAccount;
  jointOffer: Option;
  isPayer: boolean;
  smartphoneOfferClickedEvent: any;
  fetching: boolean;
  isProductOfferEligibleForPenalty = false;
  mobileToken: string;

  constructor(
    private store: Store<ApplicationState>,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.fetching = true;
    if (this.isADeeplink()) {
      this.addSubscription(
        this.route.params.subscribe((params) => {
          if (!!params && params['token']) {
            this.mobileToken = params['token'];
          }

          if (this.mobileToken) {
            this.getProducts();
            this.addSubscription(
              this.store.select(getUserProduct).subscribe((userProduct) => {
                if (
                  userProduct &&
                  ((userProduct.packs && userProduct.packs.length > 0) ||
                    (userProduct.outOfPacks &&
                      userProduct.outOfPacks.length > 0))
                ) {
                  const productsAvailableForDeepLink =
                    this.filterMobilesProducts(
                      userProduct.packs,
                      userProduct.outOfPacks,
                      this.mobileToken,
                    );

                  if (
                    !productsAvailableForDeepLink ||
                    productsAvailableForDeepLink.length !== 1
                  ) {
                    this.routeToOverview();
                  } else {
                    savePii(productsAvailableForDeepLink[0]?.accessNumber);
                    this.loadData();
                  }
                }
              }),
            );
          } else {
            this.routeToOverview();
          }
        }),
      );
    } else {
      this.loadData();
    }
  }

  private loadData() {
    this.store.dispatch(
      new GetProductDetails({
        productType: 'mobile',
        serviceId: getPiiServiceId(),
      }),
    );

    this.addSubscription(
      this.store.select(getSelectedProductDetails).subscribe((value) => {
        if (value && value.mobileProductDetails) {
          this.mobileProductDetails = value.mobileProductDetails;
          this.addSubscription(
            this.customerService.getCustomerAccount().subscribe((v) => {
              this.customerAccount = v;
            }),
          );
          if (this.mobileProductDetails) {
            this.jointOffer = getFirstJointOffer(this.mobileProductDetails);
            this.isProductOfferEligibleForPenalty =
              !!this.jointOffer?.isProductOfferEligibleForPenalty;
            this.isPayer = isPayer(
              this.mobileProductDetails,
              this.customerAccount,
            );
            this.smartphoneOfferClickedEvent = {
              event: 'click',
              event_location: 'myproducts.mobile',
              event_detail: 'go to smartphone offers',
            };
          }
          this.fetching = false;
          if (this.isADeeplink() && !this.isProductOfferEligibleForPenalty) {
            this.routeToOverview();
          }
        }
      }),
    );
  }

  private isADeeplink() {
    return this.router.url.includes('/deeplink');
  }

  private filterMobilesProducts(
    packs: any,
    outOfPacks: any,
    endPhoneNumber: string,
  ): MobileProduct[] {
    const listOfMobilePlcs = [
      PlcCodes.MI,
      PlcCodes.MV,
      PlcCodes.MMI,
      PlcCodes.MMV,
    ];

    const mobileProducts: Array<MobileProduct> = [];
    for (const pack of packs) {
      const coreProducts = pack?.coreProducts;
      const mobileProduct: Array<MobileProduct> = coreProducts.filter(
        (product) =>
          product &&
          listOfMobilePlcs.includes(product.plc) &&
          product?.accessNumber?.endsWith(endPhoneNumber),
      );
      mobileProducts.push(...mobileProduct);
    }
    for (const outOfPack of outOfPacks) {
      const coreProducts = outOfPack?.coreProducts;
      const mobileProduct: Array<MobileProduct> = coreProducts.filter(
        (product) =>
          product &&
          listOfMobilePlcs.includes(product.plc) &&
          product?.accessNumber?.endsWith(endPhoneNumber),
      );
      mobileProducts.push(...mobileProduct);
    }
    return mobileProducts;
  }

  private getProducts() {
    const appBrand = this.translationService.getTranslatedValueFor('app.brand');
    this.store.dispatch(
      new ProductsActions.GetProducts({
        appBrand: appBrand ? appBrand : 'proximus',
      }),
    );
  }

  private routeToOverview() {
    this.router.navigate(['/overview']);
  }
}
